import { useEffect } from 'react';

export function callPageAnalytics(
  name: string,
  properties?: Record<string, any>,
) {
  window.analytics?.page(name, properties);
}

export function useAnalytics(
  name: string,
  properties?: Record<string, any>,
  dependencies?: any[],
) {
  useEffect(() => {
    callPageAnalytics(name, properties);
  }, dependencies || []);
}
